import { createReducer, on } from '@ngrx/store';
import { initialNotificationsState } from './notifications.state';
import * as NotificationsActions from './notifications.actions';

export const notificationsReducer = createReducer(
  initialNotificationsState,

  on(
    NotificationsActions.loadNotificationsPage,
    (state, { filter, page, pageSize, showLoading }) => ({
      ...state,
      page: {
        ...state.page,
        filter,
        page,
        pageSize,
        loading: showLoading,
        error: null,
      },
    })
  ),

  on(NotificationsActions.loadNotificationsPageSuccess, (state, { items, totalItems }) => ({
    ...state,
    page: {
      ...state.page,
      items,
      totalItems,
      loading: false,
      error: null,
      hasLoaded: true,
    },
  })),

  on(NotificationsActions.loadNotificationsPageFailure, (state, { error }) => ({
    ...state,
    page: {
      ...state.page,
      loading: false,
      error,
    },
  })),

  on(NotificationsActions.setUnreadCount, (state, { unreadCount }) => ({
    ...state,
    unreadCount,
  }))
);
